package org.ksdfv.thelema.img

import org.ksdfv.thelema.gl.GL
import org.ksdfv.thelema.gl.GL_FRAMEBUFFER
import org.ksdfv.thelema.gl.GL_RENDERBUFFER

class RenderBufferAttachment(
    override var attachment: Int,
    override var internalFormat: Int,
    override var glHandle: Int = 0
): IFrameBufferAttachment {
    override val target: Int
        get() = GL_RENDERBUFFER

    override val isRenderBuffer: Boolean
        get() = true

    override val texture: ITexture?
        get() = null

    override fun setup(frameBuffer: IFrameBuffer) {
        if (glHandle == 0) glHandle = GL.glGenRenderbuffer()
        GL.glBindRenderbuffer(GL_RENDERBUFFER, glHandle)
        GL.glRenderbufferStorage(GL_RENDERBUFFER, internalFormat, frameBuffer.width, frameBuffer.height)
        GL.glFramebufferRenderbuffer(GL_FRAMEBUFFER, attachment, GL_RENDERBUFFER, glHandle)
        GL.glBindRenderbuffer(GL_RENDERBUFFER, 0)
    }

    override fun destroy() {
        if (glHandle != 0) {
            GL.glDeleteRenderbuffer(glHandle)
            glHandle = 0
        }
    }
}
